/* TYB: the Broadcast sticky cart bar must never bypass Easify configuration. */
(() => {
  'use strict';

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('cart-bar [data-cart-bar-scroll]');
      if (!button) return;

      const productInfo = button.closest('product-info');
      if (!productInfo) return;

      const easifyOptions =
        productInfo.querySelector('.easify-product-options') ||
        productInfo.querySelector('[class*="easify" i][class*="option" i]') ||
        productInfo.querySelector('[id*="easify" i]');

      if (!easifyOptions) return;

      event.preventDefault();
      event.stopPropagation();

      const top = easifyOptions.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    },
    true
  );
})();
